import styled, { css } from "styled-components/macro";
import {
  TOP_PADDING,
  ROW_PADDING,
  ROW_HEIGHT,
  TICK_FONT_SIZE,
  OUT_OF_FOCUS_OPACITY,
} from "../../../constants/constants";
import { darkGrey } from "../../../constants/colors";
import { getIsTouchDevice } from "utils/getIsTouchDevice";

export const TICKS_TRANSLATE_Y =
  TOP_PADDING + 2 * ROW_PADDING + ROW_HEIGHT / 2 - 1;

const TEXT_SHADOW_RADIUS = 2;
const TimeAxisSvgStyles = styled.svg<{
  $isDarkMode: boolean;
  $isTakingSnapshot?: boolean;
  $isSingleTimeline: boolean;
  $subTimelinesScrollPaddingBottom: boolean;
}>`
  width: 100%;
  overflow: visible;
  .tick text {
    text-shadow:
      -${TEXT_SHADOW_RADIUS}px -${TEXT_SHADOW_RADIUS}px 0 #${props => (props.$isDarkMode ? "000" : "fff")},
      ${TEXT_SHADOW_RADIUS}px -${TEXT_SHADOW_RADIUS}px 0 #${props =>
          props.$isDarkMode ? "000" : "fff"},
      -${TEXT_SHADOW_RADIUS}px ${TEXT_SHADOW_RADIUS}px 0 #${props =>
          props.$isDarkMode ? "000" : "fff"},
      ${TEXT_SHADOW_RADIUS}px ${TEXT_SHADOW_RADIUS}px 0 #${props => (props.$isDarkMode ? "000" : "fff")};
  }
  ${props =>
    getIsTouchDevice() && !props.$isTakingSnapshot
      ? css`
          /* increase draggable area on touch devices */
          padding-top: 40px;
          margin-top: -40px;
          padding-bottom: 40px;
          margin-bottom: -40px;
        `
      : ""}
  ${props =>
    props.$isSingleTimeline
      ? css`
          /* add some invisible padding so that scrolling on this area causes a timeline zoom instead of a page scroll  */
          padding-bottom: ${props =>
            props.$subTimelinesScrollPaddingBottom}px !important;
          margin-bottom: ${props =>
            -props.$subTimelinesScrollPaddingBottom}px !important;
          padding-top: 40px;
          margin-top: -40px;
        `
      : ""}
  .timescale {
    .domain {
      stroke: none;
    }
    &.minorTicks {
      .tick {
        stroke-dasharray: 0.5, 0.5;
      }
    }
    &.hideMinorTicksUnderMajorTicks {
      .tick {
        line {
          stroke: #ffffff;
          stroke-width: 2px;
        }
      }
    }
    &.majorTicks {
      .tick {
        font-size: ${TICK_FONT_SIZE}px;
        stroke-width: 2px;
      }
    }
  }
  .tick line {
    pointer-events: none;
  }
  .outOfFocusPath {
    fill: ${darkGrey};
    opacity: ${OUT_OF_FOCUS_OPACITY};
    pointer-events: none;
  }
  .modalVertical {
    pointer-events: none;
    path {
      stroke: black;
      stroke-width: 1px;
    }
  }
`;
export default TimeAxisSvgStyles;
